import DamageSchemeTab from './pages/tabs/DamageSchemeTab';
import RepairsSchemeTab from './pages/tabs/RepairsSchemeTab';
import EvaluationTab from './pages/tabs/EvaluationTab';
import AttentionTab from './pages/tabs/AttentionTab';
import PhotosTab from './pages/tabs/PhotosTab';
import OwnerTab from './pages/tabs/OwnerTab';
import BasicTab from './pages/tabs/BasicTab';
import EquipmentTab from './pages/tabs/EquipmentTab';
import SalesPointsTab from './pages/tabs/SalesPointsTab';
import ConfirmForSelfInsTab from './pages/tabs/ConfirmForSelfInsTab';

export default [
  {
    name: 'owner',
    path: 'owner',
    component: OwnerTab,
    title: 'オーナー情報',
  },
  {
    name: 'basic',
    path: 'basic',
    component: BasicTab,
    title: '基本情報',
  },
  {
    name: 'equipment',
    path: 'equipment',
    component: EquipmentTab,
    title: '装備品',
  },
  {
    name: 'sales-points',
    path: 'sales-points',
    component: SalesPointsTab,
    title: 'セールスポイント',
  },
  {
    name: 'photos',
    path: 'photos',
    component: PhotosTab,
    title: '写真',
  },
  {
    name: 'damages',
    path: 'damages',
    component: DamageSchemeTab,
    title: '破損',
  },
  {
    name: 'attention',
    path: 'attention',
    component: AttentionTab,
    title: '注意事項',
  },
  {
    name: 'repairs',
    path: 'repairs',
    component: RepairsSchemeTab,
    title: '修復歴',
  },
  {
    name: 'confirm-for-self-ins',
    path: 'confirm-for-self-ins',
    component: ConfirmForSelfInsTab,
    title: '出品者申告',
    hidden: true,
  },
  {
    name: 'evaluation',
    path: 'evaluation',
    component: EvaluationTab,
    title: '評価',
  },
  {
    path: '',
    redirect: { name: 'owner' },
    hidden: true,
  },
];



// WEBPACK FOOTER //
// ./src/tabs.js